module.exports = __webpack_public_path__ + "55f01b21c2331c7879c82a1095bf478c.woff";